import React from 'react'
import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp'

export default function AboutUs() {

    // const leadership = [

    //     {
    //         scr: "https://albidayahgroups.com/Media/About_Us/Color%20Fill%202.png",
    //         title: "Taun Haji Mohamed Nasar",
    //     },
    //     {
    //         scr: "https://albidayahgroups.com/Media/About_Us/Color%20Fill%202%20copy.png",
    //         title: "Leadership",
    //     },
    //     {
    //         scr: "https://albidayahgroups.com/Media/About_Us/Color%20Fill%202%20copy%202.png",
    //         title: "Ahmad Anwar Shah Bin Mohamed Nasar",
    //     },
    //     {
    //         scr: "https://albidayahgroups.com/Media/About_Us/Color%20Fill%202%20copy%203.png",
    //         title: "Leadership",
    //     },

    // ]



    const leadership = [
        // {
        //     scr: "https://albidayahgroups.com/Media/About_Us/Color%20Fill%202.png",
        //     title: "Taun Haji Mohamed Nasar",
        //     description: "Founder of AL-BIDAYAH, his vision laid the foundation of our legacy.",
        // },
        {
            scr: "https://albidayahgroups.com/Media/About_Us/Color%20Fill%202%20copy.png",
            title: "Mr. Burhan Mohamed",
            role: "Chief Executive Officer",
            description: "As the Chief Executive Officer, Burhan Mohamed blends heritage with modern vision. Armed with global experience and strategic foresight, he has been instrumental in scaling AL-BIDAYAH to over 20+ outlets, taking the brand to new heights while staying true to its roots.",
        },
        {
            scr: "https://albidayahgroups.com/Media/About_Us/Color%20Fill%202%20copy%202.png",
            title: "Mr. Ahmad Anwar Shah",
            role: "Director",
            description: " Director Ahmad Anwar Shah is the digital architect behind AL-BIDAYAH’s evolution. With a focus on innovation, he introduced advanced systems and customer engagement tools, transforming traditional operations into seamless, tech-enabled experiences.",
        },
        {
            scr: "https://albidayahgroups.com/Media/About_Us/Color%20Fill%202%20copy%203.png",
            title: "Mr. Mohamed Faizul bin Shariff",
            role: "Director",
            description: "As Director, Mohamed Faizul bin Shariff plays a key role in operational excellence and business strategy. His dedication to quality, efficiency, and sustainable growth ensures AL-BIDAYAH runs with consistency and forward momentum.",
        },
    ];

    return (
        <div className='relative'>
            <div
                className="absolute inset-0 bg-cover bg-center opacity-10"
                style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Restaurant/pattern%20bg.svg')` }}
            ></div>
            <div className='relative z-50'>
                <div className='px-80 xl:px-80 sm:px-40 max-sm:px-5 py-20'>
                    <div className='bg-[#FFB400] rounded-3xl'>
                        <img src='https://albidayahgroups.com/Media/About_Us/grp%20img.png' alt='About Us' />
                        <FadeInSectionDownToUp>
                            <div className='p-10'>
                                <p className='text-[#363636] text-4xl max-sm:text-3xl font-bold pb-3'>Board of Directors</p>
                                <p className='text-[#363636] text-xl w-1/2 max-sm:w-full'>
                                    Provides strategic direction, oversees
                                    risk management,and ensures ethical
                                    conduct across all businesses.
                                </p>
                            </div>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
                <div className='px-20 xl:px-20 sm:px-10 max-sm:px-5 pb-20 max-sm:pb-10 space-y-10'>
                    <FadeInSectionDownToUp>
                        <div>
                            <p className='text-3xl text-center font-semibold'>Executive Leadership Team</p>
                        </div>
                    </FadeInSectionDownToUp>
                    <FadeInSectionDownToUp>
                        <p className='text-xl text-center px-80 xl:px-80 sm:px-20 max-sm:px-5'>“Executive Leadership Team Comprises heads of each business unit
                            who drive operational efficiency and ensure alignment with the overall
                            Corporate strategy.”</p>
                    </FadeInSectionDownToUp>
                    <FadeInSectionDownToUp>
                        <div
                            className="bg-[#F8F8F8] rounded-3xl flex max-sm:flex-col-reverse justify-center items-center gap-10 px-20 xl:px-20 sm:px-10 max-sm:px-5 xl:py-5 sm:py-10 max-sm:py-10 my-10 relative overflow-hidden"
                        >
                            {/* Flipped background image overlay */}
                            <div
                                className="absolute inset-0 bg-no-repeat bg-[length:auto_50%] bg-left-bottom scale-x-[-1] pointer-events-none z-0"
                                style={{
                                    backgroundImage: `url('https://albidayahgroups.com/Media/Home/Frame%20314041.png')`,
                                    opacity: "0.4"
                                }}
                            />

                            {/* Content layer */}
                            <div className="w-full z-10">
                                <FadeInSectionDownToUp>
                                    <p className="text-3xl text-[#0D8F94] font-bold pb-3">Mr. Haji Mohamed Nasar</p>
                                    <p className="text-2xl text-[#FF6557] pb-3">Chairman & Founder</p>
                                    <p className="text-xl text-justify">
                                        Mr. Haji Mohamed Nasar, with over 30 years of experience, turned AL-BIDAYAH from a humble
                                        eatery into a leading 24-hour dining brand. His visionary leadership, passion, and commitment to
                                        tradition and quality continue to shape the company’s success.
                                    </p>
                                </FadeInSectionDownToUp>
                            </div>

                            <div className="w-1/4 max-sm:w-1/2 z-10">
                                <FadeInSectionDownToUp>
                                    <img
                                        src="https://albidayahgroups.com/Media/About_Us/Color%20Fill%202.png"
                                        alt="AL-BIDAYAH"
                                    />
                                </FadeInSectionDownToUp>
                            </div>
                        </div>
                    </FadeInSectionDownToUp>
                    <FadeInSectionDownToUp>
                        {/* <div className='flex justify-center items-center'>
                        <div className='grid grid-cols-4 max-sm:grid-cols-2 gap-10'>
                            {leadership.map((lead, index) => (
                                <img key={index} src={lead.scr} alt={lead.title} />
                            ))}
                        </div>
                    </div> */}
                        <div className='grid grid-cols-3 max-sm:grid-cols-1 gap-8'>
                            {leadership.map((lead, index) => (
                                <div
                                    key={index}
                                    className='relative bg-[#F8F8F8] border rounded-xl shadow-md overflow-hidden px-5 py-10'
                                >
                                    {/* Leader Image */}
                                    <div className=' flex justify-center'>
                                    <img
                                        src={lead.scr}
                                        alt={lead.title}
                                        className='w-1/2 h-auto object-contain mb-4'
                                    />
                                    </div>

                                    {/* Title */}
                                    <h3 className='text-3xl font-semibold text-[#0D8F94]'>{lead.title}</h3>
                                    <h3 className='text-xl text-[#FF6557]'>{lead.role}</h3>

                                    {/* Description */}
                                    <p className='text-lg text-justify mt-2'>{lead.description}</p>

                                    {/* Decorative Pattern */}
                                    <img
                                        src="https://albidayahgroups.com/Media/Home/Frame%20314041.png"
                                        alt="Pattern"
                                        className='absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full opacity-40'
                                    />
                                </div>
                            ))}
                        </div>
                    </FadeInSectionDownToUp>
                </div>
                <div>
                    <div className='flex justify-center items-center px-40 xl:px-40 sm:px-20 max-sm:px-5 pt-10 pb-40'>
                        <div className='grid grid-cols-3 max-sm:grid-cols-1 gap-20 max-sm:gap-10'>
                            <FadeInSectionDownToUp>
                                <div className='space-y-5'>
                                    <p className='text-3xl xl:text-3xl sm:text-2xl text-[#FF6557] font-bold'>
                                        Corporate Policies & <br className='max-sm:hidden' />
                                        Compliance.</p>
                                    <p className='text-xl'>Uniform governance policies
                                        covering finance, HR, data
                                        privacy, legal, and sustainability
                                        are enforced across the
                                        organization.</p>
                                </div>
                            </FadeInSectionDownToUp>
                            <FadeInSectionDownToUp>
                                <div className='space-y-5'>
                                    <p className='text-3xl xl:text-3xl sm:text-2xl text-[#F09615] font-bold'>
                                        IT & Data <br className='max-sm:hidden' />
                                        Governance.</p>
                                    <p className='text-xl'>Standardised data management
                                        and cybersecurity practices
                                        ensure confidentiality,
                                        availability, and integrity of
                                        business information.</p>
                                </div>
                            </FadeInSectionDownToUp>
                            <FadeInSectionDownToUp>
                                <div className='space-y-5'>
                                    <p className='text-3xl xl:text-3xl sm:text-2xl text-[#0D8F94] font-bold'>
                                        Risk & Audit <br className='max-sm:hidden' />
                                        Committees</p>
                                    <p className='text-xl'>Conduct regular evaluations
                                        and audits to ensure regulatory
                                        compliance, financial integrity,
                                        and mitigation of operational
                                        risks.</p>
                                </div>
                            </FadeInSectionDownToUp>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
